import {Grid} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React, {PropsWithChildren} from 'react'

import ChevronIcon from '../icons/ChevronIcon'
import {dropdownClasses} from './Dropdown.classes'

export type DropDownProps = {
  dropdownContent: JSX.Element
}

export function DropDown({children, dropdownContent}: PropsWithChildren<DropDownProps>): React.ReactElement {
  return (
    <Grid className={dropdownClasses.root} item>
      <Grid alignItems="center" wrap="nowrap" container>
        {children}
        <ChevronIcon className={dropdownClasses.icon} />
      </Grid>
      <Grid className={dropdownClasses.dropdown} item>
        <Grid className={clsx(dropdownClasses.dropdownContent)} item>{dropdownContent}</Grid>
      </Grid>
    </Grid>
  )
}
